'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactI18next = require('react-i18next');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./FineUploader.scss');

var TotalProgress = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TotalProgress, _Component);

  function TotalProgress() {
    var _ref;

    (0, _classCallCheck3.default)(this, TotalProgress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = TotalProgress.__proto__ || (0, _getPrototypeOf2.default)(TotalProgress)).call.apply(_ref, [this].concat(args)));

    _this.onAllComplete = function () {
      _this.setState({ hidden: true });
    };

    _this.onSubmitted = function () {
      _this.setState({ hidden: false });
    };

    _this.state = { hidden: false };

    var uploader = _this.props.uploader;

    uploader.on('allComplete', _this.onAllComplete);
    uploader.on('submitted', _this.onSubmitted);
    return _this;
  }

  (0, _createClass3.default)(TotalProgress, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      var uploader = this.props.uploader;


      (0, _get3.default)(TotalProgress.prototype.__proto__ || (0, _getPrototypeOf2.default)(TotalProgress.prototype), 'componentWillUnmount', this).call(this, function () {
        uploader.off('allComplete', _this2.onAllComplete);
        uploader.off('submitted', _this2.onSubmitted);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          uploader = _props.uploader,
          altStyle = _props.altStyle,
          t = _props.t;
      var hidden = this.state.hidden;


      return _react2.default.createElement(
        'div',
        { className: styles.totalProgress, hidden: hidden },
        _react2.default.createElement(_components.UploaderFilesize, { uploader: uploader, className: styles.fileSize }),
        _react2.default.createElement(_components.ProgressBar, { uploader: uploader, timeLeftClass: styles.timeLeft, showLeftTime: true, altStyle: altStyle }),
        _react2.default.createElement(
          'div',
          { className: styles.bottomLine },
          _react2.default.createElement(
            'span',
            { className: 'pull-left' },
            t('Total')
          ),
          _react2.default.createElement(_components.UploadStatus, { uploader: uploader, className: 'pull-right' })
        )
      );
    }
  }]);
  return TotalProgress;
}(_ClientSideComponent2.default), _class2.propTypes = {
  altStyle: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  uploader: _propTypes2.default.object
}, _class2.defaultProps = {
  multiple: true
}, _temp)) || _class);
exports.default = TotalProgress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/TotalProgress.js
// module id = 2001
// module chunks = 1